import React from "react"
import { StaticQuery, graphql, Link } from 'gatsby'
import Img from "gatsby-image"

export default () => (
    <StaticQuery
        query={graphql`
        query {
            logo: file(relativePath: { eq: "staffchecks.jpg" }) {
                childImageSharp {
                    fluid(maxWidth: 300) {
                        ...GatsbyImageSharpFluid_withWebp_noBase64
                    }
                }
            }
        }
    `}
    render = { data => (
        <div className="">
        <div className="layout header nav__sticky">
            <div className="layout__container">
                <div className="layout__nav" style={{ position: 'relative' }}>
                    {/* Christmas Closure Announcement - Absolutely positioned and centered on desktop, displayed below on mobile */}
                    {/* <div className="christmas-announcement-desktop">
                        <div style={{ textAlign: 'center' }}>
                            <span style={{ color: 'red', fontStyle: 'italic'}}>
                                <strong>Christmas Closure</strong><br />
                                StaffChecks last day for the year will be 4.00pm, Tuesday, 23rd December 2025 to Monday, 12th January,
                                when we resume normal operations.
                            </span>
                            <br/>
                            <span style={{ color: 'black' }}>
                                We would like to take this opportunity to wish you and your team a very Merry Christmas and a Prosperous New Year.
                            </span>
                        </div>
                    </div> */}
                    
                    <div className="grid grid__nav align__items">
                        <div>
                            <Link to="/"><Img fluid={data.logo.childImageSharp.fluid} backgroundColor={`#fff`} alt="StaffChecks" /></Link>
                        </div>
                        
                        <nav className="nav nav__right">
                            <ul>
                                <li><a href="https://portal.staffchecks.com" rel="nofollow noopener" className="login">Login &rsaquo;</a></li>
                            </ul>
                            <ul className="nav__mobile__off sf__menu">
                                <li><Link to="/" activeClassName="active">Home</Link></li>
                                <li><Link to="/background-checks/" activeClassName="active" partiallyActive={true}>Background Checks</Link></li>
                                <li><Link to="/about/" activeClassName="active" partiallyActive={true}>About</Link></li>
                                <li><Link to="/contact/" activeClassName="active">Contact</Link></li>
                            </ul>
                        </nav>
                    </div>
                </div>
                {/* Mobile Christmas Closure Announcement - Displayed below layout__container */}
                {/* <div className="christmas-announcement-mobile">
                    <div style={{ textAlign: 'center' }}>
                        <span style={{ color: 'red', fontStyle: 'italic' }}>
                            <strong>Christmas Closure</strong><br />
                            StaffChecks last day for the year will be 4.00pm, Tuesday, 23rd December 2025 to Monday, 12th January,<br />
                            when we resume normal operations.<br />
                        </span>
                        <span style={{ color: 'black' }}>
                            We would like to take this opportunity to wish you and your team a very Merry Christmas and a Prosperous New Year.
                        </span>
                    </div>
                </div> */}
            </div>
        </div>
        </div>
    )}
    />
)
